import React from 'react';
import type { RescueUnassignedInventoryDeviceItemGql } from '../../lib/rescueQueries';
import Button from '../../components/Button/Button';
import ActionMenu from '../../components/ActionMenu/ActionMenu';
import { canMarkLostOrInoperable } from './MarkDeviceStatusModal';
import styles from './Devices.module.scss';

const EM_DASH = '\u2014';

interface UnassignedDeviceRowProps {
  device: RescueUnassignedInventoryDeviceItemGql;
  onAssign: (moduleId: string) => void;
  /** Mark lost / Mark inoperable; wired only for partners that read the inventory ledger. */
  onMarkLost?: (moduleId: string) => void;
  onMarkInoperable?: (moduleId: string) => void;
}

export default function UnassignedDeviceRow({
  device,
  onAssign,
  onMarkLost,
  onMarkInoperable,
}: UnassignedDeviceRowProps) {
  const canMark = canMarkLostOrInoperable(device.inventoryState) && !!(onMarkLost || onMarkInoperable);
  return (
    <tr>
      <td>
        <div className={styles.deviceId}>{device.moduleId}</div>
        <div className={styles.deviceType}>{device.type ?? EM_DASH}</div>
      </td>
      <td>
        {canMark ? (
          <ActionMenu
            ariaLabel={`Actions for device ${device.moduleId}`}
            items={[
              { label: 'Add Pet', onSelect: () => onAssign(device.moduleId) },
              !!onMarkLost && { label: 'Mark Lost', onSelect: () => onMarkLost(device.moduleId), dividerBefore: true },
              !!onMarkInoperable && {
                label: 'Mark Inoperable',
                onSelect: () => onMarkInoperable(device.moduleId),
                danger: true,
              },
            ]}
          />
        ) : (
          <Button variant="green" size="sm" onClick={() => onAssign(device.moduleId)}>
            Add Pet
          </Button>
        )}
      </td>
    </tr>
  );
}
